(function () {
  'use strict';

  if (!window.customElements) return;
  if (window.customElements.get('sticky-add-to-cart')) return;

  class StickyAddToCart extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
      this.footerObserver = null;
      this.onAdd = this.onAdd.bind(this);
      this.onSectionUnload = this.onSectionUnload.bind(this);
    }

    connectedCallback() {
      this.bar = this.querySelector('[data-stuck]');
      this.button = this.querySelector('[data-sticky-add]');
      this.form = document.getElementById(this.dataset.formId);

      if (!this.bar || !this.button || !this.form) return;

      this.button.addEventListener('click', this.onAdd);
      document.addEventListener('shopify:section:unload', this.onSectionUnload);

      this.setupObservers();
    }

    disconnectedCallback() {
      if (this.button) {
        this.button.removeEventListener('click', this.onAdd);
      }

      document.removeEventListener('shopify:section:unload', this.onSectionUnload);

      if (this.observer) this.observer.disconnect();
      if (this.footerObserver) this.footerObserver.disconnect();
    }

    setupObservers() {
      if (!window.IntersectionObserver) return;

      var mainButton = this.form.querySelector('#ProductAddButton');
      if (!mainButton) return;

      this.observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry) return;

        var rect = entry.target.getBoundingClientRect();

        if (!entry.isIntersecting && rect.bottom < 0) {
          this.show();
        } else if (entry.isIntersecting) {
          this.hide();
        }
      }.bind(this), {
        threshold: 0
      });

      this.observer.observe(mainButton);

      var footer = document.querySelector('footer');
      if (!footer) return;

      this.footerObserver = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry) return;

        if (entry.isIntersecting) {
          this.hide();
        }
      }.bind(this), {
        threshold: 0
      });

      this.footerObserver.observe(footer);
    }

    show() {
      if (this.dataset.variantAvailable === 'false') return;
      this.bar.setAttribute('data-stuck', 'true');
    }

    hide() {
      this.bar.setAttribute('data-stuck', 'false');
    }

    onAdd() {
      if (!this.form) return;

      var mainButton = this.form.querySelector('#ProductAddButton');
      if (!mainButton || mainButton.disabled) return;

      mainButton.click();
    }

    onSectionUnload(event) {
      if (!event.detail) return;

      var section = this.closest('.shopify-section');
      if (!section) return;

      if (section.id === 'shopify-section-' + event.detail.sectionId) {
        this.disconnectedCallback();
      }
    }
  }

  window.customElements.define('sticky-add-to-cart', StickyAddToCart);
})();
